import "./app.ts"

document.querySelector<HTMLDivElement>('#app')!.innerHTML = `
  
    <!-- Header -->
    <div class="bulma-contextual">

        <div class="notification is-light">
            <button class="delete"></button>
            <div class="notification-body">
            </div>
        </div>

        <nav class="navbar app__header">

            <a class="brand-logo navbar-brand p-5">
                <figure class="image">
                    <img src="images/logo/eilersen-logo-2x.png" alt="Eilersen" />
                </figure>
            </a>

            <div class="navbar-menu is-active p-0">
                <div class="navbar-start">
                    <div class="navbar-item p-5">
                        <button class="back-button button is-black-hover is-bordered is-rounded">
                            <span class="icon">
                                <i class="fas fa-chevron-left"></i>
                            </span>
                        </button>
                    </div>
                </div>

                <div class="navbar-end ml-auto">
                    <div class="navbar-item p-5">

                        <div class="columns is-mobile">
                            <div class="column is-flex is-align-items-center">
                                <div class="summary-menu">
                                    <div class="summary-menu__series">
                                        <span class="summary-menu__series__name"></span>
                                    </div>
                                    <div class="summary-menu__price">
                                        <span class="summary-menu__price__currency"></span>
                                        <span class="summary-menu__price__value"></span>
                                        <!--<span class="summary-menu__price__vat">incl. 25% VAT</span>-->
                                    </div>
                                </div>
                            </div>
                            <div class="column is-flex is-align-items-center">
                                <div class="user-menu is-flex">
                                    <div class="columns is-mobile">
                                        <div class="column">
                                            <button class="summary-menu__button button is-default is-black-hover is-bordered is-radiusless">
                                                <span data-i18n>common.summary</span>
                                                <span class="icon">
                                                    <i class="fas fa-long-arrow-alt-right"></i>
                                                </span>
                                            </button>
                                        </div>
                                        <div class="column">
                                            <div class="user-menu__wrapper">
                                                <span class="user-menu__label">
                                                </span>
                                                <div class="dropdown is-right">
                                                    <div class="dropdown-trigger">
                                                        <button class="user-menu__button button is-black-hover is-bordered is-rounded" aria-haspopup="true" aria-controls="dropdown-menu">
                                                            <span class="icon">
                                                                <i class="fas fa-user"></i>
                                                            </span>
                                                        </button>
                                                    </div>
                                                    <div class="dropdown-menu">
                                                        <div class="dropdown-content">
                                                            <a href="#" id="projects" class="dropdown-item">
                                                                <span class="icon is-small"><i class="fas fa-list"></i></span>
                                                                <span>Configurations</span>
                                                            </a>
                                                            <a href="#" id="logout" class="dropdown-item">
                                                                <span class="icon is-small"><i class="fas fa-unlock"></i></span>
                                                                <span>Logout</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!--<div class="user-menu dropdown-menu box">
                                                <ul>
                                                    <li class="projects">
                                                        <span class="icon is-small"><i class="fas fa-long-arrow-right"></i></span>
                                                        <span>Projects</span>

                                                    </li>
                                                    <li class="logout has-icons-left">
                                                        <span class="icon is-small"><i class="fas fa-long-arrow-right"></i></span>
                                                        <span>Logout</span>
                                                    </li>
                                                </ul>
                                            </div>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>

    <!-- Main -->
    <main class="app__main">

        <div class="loader-wrapper bulma-contextual">
            <div class="loader is-primary is-loading"></div>
        </div>

        <!-- Login -->
        <div class="login-page page bulma-contextual" data-page="login">
            <div class="page__content columns is-gapless is-centered is-vcentered">
                <div class="column is-12-mobile is-10-tablet">

                    <div class="columns is-gapless">
                        <div class="column is-12-mobile is-6-tablet is-3-widescreen">

                            <div class="login">
                                <section class="section">
                                    <div class="mb-6">

                                        <h1 class="title is-1">Log in</h1>
                                        <p class="mb-6">
                                            Log in to Eilersen Sofa Configurator (Internal)
                                        </p>

                                        <div class="simple-input field">
                                            <div class="control">
                                                <input id="email" name="email" type="email" class="input is-shadowless is-radiusless" placeholder="E-mail address*" />
                                            </div>
                                        </div>
                                        <div class="simple-input field">
                                            <div class="control">
                                                <input id="password" name="password" type="password" class="input is-shadowless is-radiusless" placeholder="Password*" />
                                            </div>
                                        </div>
                                        <div class="field mb-6">
                                            <div class="control">
                                                <a href="https://secure.workbooks.com/process/5YDN0UTM/case_portal?function=show_open_cases" class="is-link" target="_blank">Forgot password?</a>
                                            </div>
                                        </div>
                                        <div class="field">
                                            <div class="control">
                                                <button class="login-btn button is-default is-dark is-radiusless is-fullwidth">
                                                    <span>Log in</span>
                                                    <span class="icon is-small is-right">
                                                        <i class="fas fa-long-arrow-alt-right"></i>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <!-- Configurations -->
        <div class="configurations-page page bulma-contextual" data-page="configurations">
            <div class="page__content columns is-gapless is-centered">
                <div class="column is-12-mobile is-10-tablet">
                    <div class="mb-5">
                        <h3 class="title is-3" data-i18n>page.configuration.savedconfigurations</h3>
                    </div>
                    <div class="mb-5">
                        <div class="is-flex is-justify-content-space-between is-align-items-center">
                            <div class="is-flex is-align-items-center">
                                <div class="projectsearch control has-icons-left is-flex-shrink-3 mr-5">
                                    <form>
                                        <input id="projectsearch" name="projectsearch" required type="text" class="simple-input input is-shadowless is-radiusless" data-i18n placeholder="common.search" />
                                        <span class="icon is-small is-left">
                                            <i class="fas fa-search"></i>
                                        </span>
                                        <button class="icon close-icon is-right" type="reset"></button>
                                    </form>
                                </div>
                                <div class="is-flex-shrink-3">
                                    <label class="checkbox">
                                        <input id="hideinactive-projects" type="checkbox">
                                        <span data-i18n>page.configuration.hideinactive</span>
                                    </label>
                                </div>
                            </div>
                            <div class="pagenation is-flex is-align-items-center">
                                <div class="pagenation-pagecount mr-4">
                                </div>
                                <div>
                                    <button class="button first">
                                        <span class="icon is-small">
                                            <i class="fas fa-angle-double-left"></i>
                                        </span>
                                    </button>
                                    <button class="button prev">
                                        <span class="icon is-small">
                                            <i class="fas fa-angle-left"></i>
                                        </span>
                                    </button>
                                    <button class="button next">
                                        <span class="icon is-small">
                                            <i class="fas fa-angle-right"></i>
                                        </span>
                                    </button>
                                    <button class="button last">
                                        <span class="icon is-small is-left">
                                            <i class="fas fa-angle-double-right"></i>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-5">
                        <table class="project-list table is-fullwidth is-striped is-hoverable">
                            <thead>
                                <tr>
                                    <th data-i18n>projectlist.projectname</th>
                                    <th data-i18n>common.email</th>
                                    <th data-i18n>common.phonenumber</th>
                                    <th data-i18n>projectlist.projectdate</th>
                                    <th data-i18n>common.status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </div>
                    <div class="is-flex is-justify-content-flex-end">
                        <div class="field is-grouped is-horizontal mb-6">
                            <div class="control">
                                <form id="openprojectform">
                                    <div class="field has-addons simple-input is-fullheight">
                                        <div class="control mr-4">
                                            <input type="text" required class="input is-radiusless is-shadowless" data-i18n placeholder="page.configuration.typeconfigid" />
                                        </div>
                                        <div class="control">
                                            <button id="openproject-button" type="submit" class="button is-default is-black is-bordered is-radiusless">
                                                <span data-i18n>page.configuration.openconfig</span>
                                                <span class="icon is-small">
                                                    <i class="fas fa-long-arrow-alt-right"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="control">
                                <button id="newproject-button" class="button is-default is-white is-bordered is-radiusless">
                                    <span data-i18n>page.configuration.newconfig</span>
                                    <span class="icon is-small">
                                        <i class="fas fa-long-arrow-alt-right"></i>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Landing -->
        <div class="landing-page page bulma-contextual" data-page="landing">
            <div class="page__content columns is-gapless is-centered is-vcentered">
                <div class="column is-12-mobile is-10-tablet">
                    <section class="section has-text-centered">
                        <div class="columns is-centered">
                            <div class="column is-10-desktop is-6-widescreen">
                                <h1 class="title is-1">Welcome</h1>
                                <p>
                                    If you would like to open an existing configuration, type its number in the first box, then press
                                    �Open configuration�. If you would like to start a new one, select the second box.
                                </p>
                            </div>
                        </div>
                    </section>
                    <section class="section">
                        <div class="columns is-centered">
                            <div class="column is-5-tablet is-5-desktop is-3-widescreen">
                                <div class="wrapper is-flex is-justify-content-flex-end">
                                    <div class="bordered-box box is-shadowless is-radiusless">
                                        <div class="bordered-box--content">
                                            <div class="openconfig-identifier simple-input field">
                                                <div class="control">
                                                    <input type="text" class="input is-shadowless is-radiusless" placeholder="Enter configuration number" />
                                                </div>
                                            </div>
                                            <button class="openconfig-button button is-default is-dark is-radiusless">
                                                <span>Open configuration</span>
                                                <span class="icon is-small is-right">
                                                    <i class="fas fa-long-arrow-alt-right"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-5-tablet is-5-desktop is-3-widescreen">
                                <div class="wrapper is-flex is-justify-content-flex-start">
                                    <div class="bordered-box box is-shadowless is-radiusless">
                                        <div class="bordered-box--content">
                                            <button class="createconfig-button button is-default is-white is-bordered is-radiusless">
                                                <span>New Configuration</span>
                                                <span class="icon is-small is-right">
                                                    <i class="fas fa-long-arrow-alt-right"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>

        <!-- Series -->
        <div class="series-page page bulma-contextual" data-page="series">
            <div class="page__content columns is-gapless is-centered">
                <div class="column is-10">
                    <section class="section">
                        <div class="series-selection wizard-nav">
                            <!--<div class="wizard-nav__steps level">
                            <div class="level-left">
                                <div class="level-item">
                                    <label class="wizard-nav__steps__label is-uppercase">Step</label>
                                    <ul>
                                        <li data-stepview="series">
                                            <a href="#" class="wizard-nav__steps__steplink button is-small is-rounded is-active">1</a>
                                        </li>
                                        <li data-stepview="preset">
                                            <a href="#" class="wizard-nav__steps__steplink button is-small is-rounded">2</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>-->
                            <div class="wizard-nav__stepviews">

                                <div class="wizard-nav__stepview is-shown" data-stepview="series">
                                    <div class="level">
                                        <div class="level-left">
                                            <div class="seriessearch control has-icons-left is-flex-shrink-3 mr-5">
                                                <form>
                                                    <input id="seriessearch" name="seriessearch" required type="text" class="simple-input input is-shadowless is-radiusless" data-i18n placeholder="common.search" />
                                                    <span class="icon is-small is-left">
                                                        <i class="fas fa-search"></i>
                                                    </span>
                                                    <button class="icon close-icon is-right" type="reset"></button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="level">
                                        <div class="level-left">
                                            <div class="level-item">
                                                <label class="wizard-nav__stepview__label is-uppercase">Choose sofa series</label>
                                            </div>
                                        </div>
                                        <div class="level-right">
                                            <div class="level-item">
                                                <ul class="series-categories list-filter"></ul>
                                            </div>
                                        </div>
                                    </div>

                                    <ul class="freewall series-list tile-list">
                                    </ul>
                                </div>

                                <div class="wizard-nav__stepview" data-stepview="preset">
                                    <div class="level">
                                        <div class="level-left">
                                            <div class="level-item">
                                                <label class="wizard-nav__stepview__label is-uppercase">START FROM SCRATCH OR SELECT A PRESET</label>
                                            </div>
                                        </div>
                                    </div>

                                    <ul class="freewall preset-list tile-list">
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </section>

                </div>
            </div>
        </div>

        <!-- Summary -->
        <div class="summary-page page bulma-contextual" data-page="summary">
            <div class="page__content columns is-gapless is-centered page__content--summary">
                <div class="column is-flex is-flex-direction-column">
                    <section class="section p-5">
                        <h2 class="subtitle is-2 is-underscore summary__header">Summary</h2>
                    </section>
                    <div class="summary-content">

                        <section class="columns is-full is-flex-grow-1 bulma-contextual">
                            <div class="column">
                                <div class="section p-2 summary__description">

                                    <div class="tile is-ancestor pl-5 pr-5 summary__description--wrapper">
                                        <div class="tile is-parent summary__description--image">
                                            <div class="is-flex is-justify-content-center is-align-items-center">
                                                <figure class="image is-flex is-justify-content-center is-align-items-center">
                                                    <img class="summary-image" />
                                                </figure>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="tile is-ancestor pl-5 pr-5 summary__description--wrapper">
                                        <div class="tile is-parent summary__description--series">
                                            <div class="is-flex is-justify-content-center is-align-items-center">
                                                <figure class="image is-flex is-justify-content-center is-align-items-center">
                                                    <img class="summary-image" />
                                                </figure>
                                            </div>
                                            <div class="is-flex is-centered is-vcentered">
                                                <div class="is-flex is-justify-content-center is-align-items-center p-5">
                                                    <div class="summary__description--header mr-5 is-size-4"><span>Sofa series</span></div>
                                                    <div class="summary__description--value is-size-4"><span></span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tile is-parent summary__description--material">
                                            <div class="is-flex is-justify-content-center is-align-items-center">

                                                <figure class="image is-128x128 is-flex is-justify-content-center is-align-items-center">
                                                    <img class="summary-image" />
                                                </figure>

                                                <div class="is-flex is-justify-content-center is-align-items-center p-5">
                                                    <div class="summary__description--header mr-5 is-size-4"><span>Fabric selection</span></div>
                                                    <div class="summary__description--value is-size-4"><span></span></div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="tile is-ancestor pl-5 pr-5 summary__description--wrapper">
                                        <div class="tile is-parent summary__description--legs">
                                            <div class="is-flex is-justify-content-center is-align-items-center">
                                                <figure class="image is-128x128 is-flex is-justify-content-center is-align-items-center">
                                                    <img class="summary-image" />
                                                </figure>
                                            </div>
                                            <div class="is-flex is-centered is-vcentered">
                                                <div class="is-flex is-justify-content-center is-align-items-center p-5">
                                                    <div class="summary__description--header mr-5 is-size-4"><span>Legs</span></div>
                                                    <div class="summary__description--value is-size-4"><span></span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tile is-parent summary__description--options">
                                            <div class="is-flex is-centered is-vcentered">
                                                <div class="is-flex is-justify-content-center is-align-items-center p-5">
                                                    <div class="summary__description--header mr-5 is-size-4"><span>Options</span></div>
                                                    <div class="summary__description--value is-size-4"><span></span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                        <section class="columns is-full is-flex-grow-1 bulma-contextual">
                            <div class="column">
                                <div class="section p-5 summary__products">

                                    <div class="summary__table">
                                        <div class="summary__table__header is-size-4">
                                            <span>Elements</span>
                                        </div>
                                        <div class="table-container">
                                            <table class="table is-fullwidth summary__table__rows">
                                                <tbody>
                                                </tbody>
                                                <tfoot>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div class="section p-5 summary__accessories">
                                    <div class="summary__accessories__header is-size-4">
                                        <span>Accessories</span>
                                    </div>
                                    <div class="table-container">
                                        <table class="table is-fullwidth summary__accessories__list">
                                            <thead>
                                                <tr>
                                                    <th colspan="5"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            </tbody>
                                            <tfoot>
                                            </tfoot>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </section>


                        <section class="columns is-full is-flex-grow-1 bulma-contextual">
                            <div class="column">
                            
                                <div class="section p-2 summary__description">
                                    <div class="tile is-ancestor pl-5 pr-5 summary__description--wrapper">
                                        <div class="tile is-parent summary__description--drawing">
                                            <div class="is-flex is-justify-content-center is-align-items-center">
                                                <figure class="image is-flex is-justify-content-center is-align-items-center">
                                                    <img class="summary-image" />
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    <div class="summary__actions p-5">
                        <div class="is-flex is-flex-direction-column">
                            <div class="is-flex is-justify-content-flex-end is-align-items-flex-start mb-4">
                                <label class="summary__actions__terms">
                                    <input type="checkbox" name="terms"/>
                                    <span>
                                        I have read and understood the terms and conditions <a href="https://eilersen.eu/terms-and-condition" target="_blank">https://eilersen.eu/terms-and-condition</a>
                                    </span>                            
                                </label>
                            </div>
                            <div class="is-flex is-justify-content-flex-end is-align-items-flex-start mb-4">
                                <label class="summary__actions__disclaimer">
                                    <input type="checkbox" name="disclaimer" />
                                    <span>
                                        The customer has been given the following information:</br>
                                        Colors and textures may appear differently on screen than in real life.</br>
                                        Please view physical fabric or leather  samples before making your final choice.</br>
                                        Digital images are for illustration only and may not reflect actual materials.
                                    </span>
                                </label>
                            </div>
                        </div>
                        <nav class="level">
                            <div class="level-left">
                                <div class="summary__actions__confignumber level-item">
                                    <span>Confignumber:</span>
                                    <span class="summary__actions__confignumber--value"></span>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <button class="sharesave-button button is-default is-black-hover is-bordered is-radiusless">Share / save</button>
                                </div>
                                <div class="level-item">
                                    <button class="order-button button is-default is-dark is-bordered is-radiusless has-icon" disabled="disabled">
                                        <span>Order</span>
                                        <span class="icon is-small is-right">
                                            <i class="fas fa-bag-shopping"></i>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </nav>
                    </div>

                </div>
            </div>
        </div>

        <!-- Viewport -->
        <div class="viewport-page page" data-page="viewport">
            <div class="page__content page__content--viewport">
                <div class="viewport">
                    <canvas id="renderCanvas"></canvas>
                    <canvas id="loadCanvas"></canvas>
                    <!--<div class="loader-wrapper bulma-contextual">
                    <div class="loader is-primary is-loading"></div>
                </div>-->
                    <div id="renderCanvasDrop"></div>
                    <div class="errors bulma-contextual">
                        <a href="#" class="errors__button">
                            <i class="fas fa-exclamation-triangle fa-2x"></i>
                        </a>
                        <ul class="errors__items">
                            <li class="errors__items__item notification">
                            </li>
                        </ul>
                    </div>
                    <!--<button class="exportToOBJ" style="position: absolute; top: 50px; left: 0px">EXPORT</button>-->
                </div>
            </div>

            <div id="menu" class="config-menu">
                <div class="config-menu__header">
                    <a class="config-menu__close"><span data-i18n>page.viewport.menu</span></a>
                    <a class="config-menu__customize"><span data-i18n>page.viewport.customize</span></a>
                </div>

                <div class="config-menu__sections">
                    <div class="config-menu__section config-menu__section--configurations">
                        <div class="config-menu__section__header bulma-contextual">
                            <div class="tabs is-boxed is-medium is-fullwidth is-left is-disabled">
                                <ul>
                                    <li class="is-active">
                                        <a><span data-i18n>page.viewport.configurations</span></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="config-menu__section__content">
                            <div class="configuration-selector">
                                <ul>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="config-menu__section config-menu__section--menues">
                        <div class="config-menu__section__header bulma-contextual">
                            <div class="tabs is-boxed is-medium config-menu__submenu-selection">
                                <ul>
                                    <li data-menu="modules" class="is-active">
                                        <a>
                                            <span data-i18n>page.viewport.modules</span>
                                        </a>
                                    </li>
                                    <li data-menu="fabrics">
                                        <a>
                                            <span data-i18n>page.viewport.fabrics</span>
                                        </a>
                                    </li>

                                    <!--<li data-menu="customize">
                                    <a>
                                        <span>Customize</span>
                                    </a>
                                </li>-->
                                </ul>
                            </div>
                        </div>
                        <div class="config-menu__section__content">
                            <div class="config-menu__submenues">
                                <div class="config-menu__submenues__submenu is-shown" data-menuview="modules">

                                    <div class="product-selector selector">
                                        <div class="selector__wrapper">

                                            <div class="selector__tabs">
                                                <div class="selector__tabs__nav__wrapper">
                                                    <ul class="selector__tabs__nav"></ul>
                                                </div>
                                                <div class="selector__items__wrapper">
                                                    <ul class="selector__items"></ul>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                                <div class="config-menu__submenues__submenu" data-menuview="fabrics">

                                    <div class="material-selector selector">
                                        <div class="selector__wrapper">
                                            <div class="selector__nav">
                                                <div class="selector__nav__left">
                                                    <div class="material-selector__header">
                                                        <span data-i18n>page.viewport.currentmaterial</span>
                                                        <span class="material-selector__material__name"></span>
                                                    </div>
                                                </div>
                                                <div class="selector__nav__right">
                                                    <div class="material-selector__header bulma-contextual">
                                                        <div class="material-selector__header__section"><span data-i18n>page.viewport.selectedfabric</span><span class="material-selector__group__name"></span></div>
                                                        <div class="material-selector__header__section"><a class="material-selector__items__group__select" href="" data-i18n>page.viewport.selectfabric</a></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="selector__content">
                                                <div class="selector__content__left">
                                                    <div class="material-selector__material__image">
                                                    </div>
                                                </div>
                                                <div class="material-selector__items selector__content__right">
                                                    <ul class="selector__items"></ul>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <!--<div class="config-menu__submenues__submenu" data-menuview="customize">
                                <div class="options-selector selector">
                                    <div class="selector__wrapper">
                                        <div class="selector__nav">
                                            <a href="" class="selector__nav__back">
                                                <span class="icon">
                                                    <i class="fas fa-arrow-left-long"></i>
                                                </span>
                                                <span>
                                                    Back
                                                </span>
                                            </a>
                                        </div>
                                        <div class="selector__content">
                                            <ul class="selector__items"></ul>
                                        </div>
                                    </div>
                                </div>
                                <i class="fa-solid fa-ballot"></i>
                            </div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>

    <div class="modals bulma-contextual">

        <div class="placement-modal modal">
             <div class="modal-background"></div>
              <div class="modal-card">
                <div class="modal-card-head">
                    <div class="modal-card-title" data-i18n>Placement</div>                   
                </div>
                  <section class="modal-card-body">        
                   </section>  
              </div>             
        </div>

        <div class="changepassword-modal modal">
            <div class="modal-background"></div>
            <div class="modal-card">
                <div class="modal-card-head">
                    <div class="modal-card-title" data-i18n>modal.changepassword.header</div>
                    <button class="modal-card-close delete" aria-label="close"></button>
                </div>
                <section class="modal-card-body">                
                   <div class="mb-6" data-i18n>modal.changepassword.body</div>
                   <div class="field center">
                     <div class="control is-flex is-justify-content-center">
                        <button class="button is-default is-dark is-radiusless changepassword-close" aria-label="close">
                            <span data-i18n>common.close</span>
                        </button>
                     </div>
                    </div>
                </section>                
            </div>   
            <button class="modal-close is-large" aria-label="close"></button>
        </div>

        <div class="material-group-modal modal">
            <div class="modal-background"></div>
            <div class="modal-card">
                <div class="modal-card-head">
                    <nav class="modal-header-wrapper level is-mobile">
                        <div class="level-left">
                            <div class="modal-header level-item"><span data-i18n>modal.material.header</span></div>
                        </div>
                        <div class="level-right">
                            <ul class="material-group-modal-filter level-item">
                                <li>
                                    <div class="field">
                                        <div class="control has-icons-left">
                                            <input type="text" class="materialfilter simple-input input is-shadowless is-radiusless" id="materialsearchfilter" />
                                            <span class="icon is-small is-left">
                                                <i class="fas fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="field is-flex is-align-items-center">
                                        <div class="material-filter control">
                                            <input class="materialfilter is-checkradio is-block is-white" id="fabricfilter" type="checkbox" value="fabric" name="fabricfilter" checked="checked">
                                            <label for="fabricfilter" data-i18n>modal.material.fabric</label>
                                        </div>
                                        <div class="material-filter control">
                                            <input class="materialfilter is-checkradio is-block is-white" id="leatherfilter" type="checkbox" value="leather" name="leatherfilter" checked="checked">
                                            <label for="leatherfilter" data-i18n>modal.material.leather</label>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
                <section class="modal-card-body">
                    <ul>
                    </ul>
                </section>
            </div>
            <button class="modal-close is-large" aria-label="close"></button>
        </div>

        <div class="order-modal modal">
            <div class="modal-background"></div>
            <div class="modal-card">
                <div class="modal-card-head">
                    <div class="modal-card-title" dta-i18n>modal.order.order</div>
                    <button class="modal-card-close delete" aria-label="close"></button>
                </div>
                <section class="modal-card-body" data-i18n>modal.order.sent</section>
            </div>
        </div>

        <div class="editproject-modal modal">
            <div class="modal-background"></div>
            <div class="modal-card">
                <div class="modal-card-head">
                    <div class="modal-card-title" data-i18n>modal.editproject.header</div>
                    <button class="modal-card-close delete" aria-label="close"></button>
                </div>
                <section class="modal-card-body">
                    <form id="editprojectform" class="form">
                        <div class="is-flex is-justify-content-center is-align-items-center is-full mb-6">
                            <!--<h4 class="title is-4 mb-2" data-i18n>modal.editproject.header</h4>-->
                            <div class="is-flex">
                                <label class="label mr-5">
                                    <span data-i18n>modal.editproject.confignumber</span><span>:</span>
                                </label>
                            </div>
                            <span id="project-identifier"></span>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label"><span data-i18n>modal.editproject.projectname</span><span>*:</span></label>
                            </div>
                            <div class="field-body">
                                <div class="simple-input field">
                                    <p class="control is-expanded">
                                        <input id="project-name" required class="input is-shadowless is-radiusless" type="text">
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label"><span data-i18n>common.phonenumber</span><span>:</span></label>
                            </div>
                            <div class="field-body">
                                <div class="simple-input field">
                                    <p class="control is-expanded">
                                        <input id="project-phone" class="input is-shadowless is-radiusless" type="text">
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label">
                                <label class="label"><span data-i18n>common.email</span><span>:</span></label>
                            </div>
                            <div class="field-body">
                                <div class="simple-input field">
                                    <p class="control is-expanded">
                                        <input id="project-email" class="input is-shadowless is-radiusless" type="text">
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal mb-6">
                            <div class="field-label">
                                <label class="label"><span data-i18n>common.status</span>:</label>
                            </div>
                            <div class="field-body">
                                <div class="simple-input field">
                                    <div class="control is-expanded">
                                        <div class="select simple-select">
                                            <select id="project-status" class="is-shadowless is-radiusless">
                                                <option value="0" data-i18n>common.statuses.inactive</option>
                                                <option value="1" data-i18n>common.statuses.active</option>
                                                <option value="2" data-i18n>common.statuses.ordered</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="field mb-6">
                            <div class="control is-flex is-justify-content-center">
                                <button id="save-project" class="button is-default is-dark is-radiusless" type="submit">
                                    <span data-i18n>modal.editproject.save</span>
                                </button>
                            </div>
                        </div>
                        <div class="field">
                            <div class="is-flex is-justify-content-space-between">
                                <div class="field is-flex">
                                    <div class="field-label">
                                        <label class="label"><span data-i18n>modal.editproject.dateadded</span><span>:</span></label>
                                    </div>
                                    <span id="project-added"></span>
                                </div>
                                <div class="field is-flex">
                                    <div class="field-label">
                                        <label class="label"><span data-i18n>modal.editproject.datemodified</span><span>:</span></label>
                                    </div>
                                    <span id="project-modified"></span>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
            <button class="modal-close is-large" aria-label="close"></button>
        </div>

        <div class="createproject-modal modal">
            <div class="modal-background"></div>
            <div class="modal-card">
                <div class="modal-card-head">
                    <div class="modal-card-title" data-i18n>modal.newproject.header</div>
                    <button class="modal-card-close delete" aria-label="close"></button>
                </div>
                <section class="modal-card-body">
                    <form id="createprojectform" class="form">
                        <!--<div class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center is-full mb-6">
                        <h4 class="title is-4 mb-2" data-i18n>modal.newproject.newconfig</h4>
                    </div>-->
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label"><span data-i18n>modal.newproject.projectname</span><span>*:</span></label>
                            </div>
                            <div class="field-body">
                                <div class="simple-input field">
                                    <p class="control is-expanded">
                                        <input id="newproject-name" required class="input is-shadowless is-radiusless" type="text">
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label"><span data-i18n>common.phonenumber</span><span>:</span></label>
                            </div>
                            <div class="field-body">
                                <div class="simple-input field">
                                    <p class="control is-expanded">
                                        <input id="newproject-phone" class="input is-shadowless is-radiusless" type="text">
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label"><span data-i18n>common.email</span><span>:</span></label>
                            </div>
                            <div class="field-body">
                                <div class="simple-input field">
                                    <p class="control is-expanded">
                                        <input id="newproject-email" class="input is-shadowless is-radiusless" type="text">
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field mb-6">
                            <div class="control is-flex is-justify-content-center">
                                <button id="create-project" class="button is-default is-dark is-radiusless" type="submit">
                                    <span data-i18n>modal.newproject.save</span>
                                </button>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
            <button class="modal-close is-large" aria-label="close"></button>
        </div>

        <div class="options-modal modal">
            <div class="modal-background"></div>
            <div class="modal-card">
                <div class="modal-card-head">
                    <div class="modal-card-title" data-i18n>modal.options.header</div>
                    <button class="modal-card-close delete" aria-label="close"></button>
                </div>
                <section class="modal-card-body">
                    <div class="options">

                    </div>
                    <p class="mt-5">
                        <button class="renderConfiguration button is-radiusless">Render images</button>
                    </p>
                </section>
            </div>
        </div>
    </div>

`
